import { useQuery } from '@tanstack/react-query';
import {
  fetchFollowersForUser,
  fetchFollowingForUser,
  fetchSuggestedPeople,
  searchPeopleRanked,
} from '../../api/people';
import { queryKeys } from '../../lib/query/queryKeys';
import { GC, STALE } from '../../lib/query/staleTimes';

const peopleQueryDefaults = {
  staleTime: STALE.user,
  gcTime: GC.long,
};

export function useFollowingForUser(userId, { enabled = true, limit = 200 } = {}) {
  return useQuery({
    queryKey: queryKeys.people.following(userId),
    queryFn: () => fetchFollowingForUser(userId, { limit }),
    enabled: Boolean(userId) && enabled,
    ...peopleQueryDefaults,
  });
}

export function useFollowersForUser(userId, { enabled = true, limit = 200 } = {}) {
  return useQuery({
    queryKey: queryKeys.people.followers(userId),
    queryFn: () => fetchFollowersForUser(userId, { limit }),
    enabled: Boolean(userId) && enabled,
    ...peopleQueryDefaults,
  });
}

export function useSuggestedPeople(userId, { enabled = true, limit = 20 } = {}) {
  return useQuery({
    queryKey: queryKeys.people.suggested(userId, limit),
    queryFn: () => fetchSuggestedPeople(userId, { limit }),
    enabled: Boolean(userId) && enabled,
    ...peopleQueryDefaults,
  });
}

/** Full list for FollowConnections / discover modal — higher limit, separate cache key. */
export function useSuggestedPeopleDiscover(userId, { enabled = true } = {}) {
  return useQuery({
    queryKey: queryKeys.people.suggestedDiscover(userId),
    queryFn: () => fetchSuggestedPeople(userId, { limit: 500 }),
    enabled: Boolean(userId) && enabled,
    ...peopleQueryDefaults,
  });
}

export function useSearchPeopleRanked(userId, query, { enabled = true, limit = 20 } = {}) {
  const trimmed = query.trim();
  return useQuery({
    queryKey: queryKeys.people.search(userId, trimmed, limit),
    queryFn: () => searchPeopleRanked(userId, trimmed, { limit }),
    enabled: Boolean(userId) && Boolean(trimmed) && enabled,
    ...peopleQueryDefaults,
  });
}
